import React, { useEffect, useState } from "react";
import { serviceFetchOnboardedPatients } from "../../../Services/Service";
import SkeletonCard from "./SkeletonCard";

const OnboardedPatientsPopup = ({ onClose, filterForm, onboarded = 0 }) => {
  const [onBoardedPatients, setOnboardedPatients] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchOnboardedPatients = async () => {
    setLoading(true);
    try {
      const response = await serviceFetchOnboardedPatients(
        filterForm.startRange,
        filterForm.endRange,
        filterForm.divisionClinicFilter,
        filterForm.programSelect
      );

      setOnboardedPatients(response?.data?.data);
      console.log("Onboarded Patients Data:", response?.data);
    } catch (error) {
      console.error("Error fetching onboarded patients:", error);
    } finally {
      setLoading(false);
    }
  };

  console.log("Onboarded Patients:", onBoardedPatients);

  useEffect(() => {
    fetchOnboardedPatients();
  }, [filterForm]);

  const total = Number(onBoardedPatients?.whatsapp_count || 0) + Number(onBoardedPatients?.other_count || 0);
  return (
    <div
      className="modal fade show"
      id="onboardBreakdownModal"
      tabIndex="-1"
      aria-labelledby="onboardBreakdownLabel"
      aria-modal="true"
      role="dialog"
      style={{
        display: "block",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 1050,
      }}
    >
      <div
        className="modal-dialog modal-dialog-centered"
        style={{ maxWidth: "800px", width: "90%", minHeight: "80vh" }}
      >


        <div className="modal-content text-center p-5">

          <div className="d-flex justify-content-between align-items-center">
            <h2
              className="fw-bold mb-4 onboarded-popup-heading"
              id="onboardBreakdownLabel"
            >
              Total Onboarded Patients Breakdown
            </h2>
            <button onClick={onClose} type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <SkeletonCard className={`${!loading && 'd-none'}`}>
            <div>
              <div className="row mb-4">
                <p className="col-3  placeholder"></p>
                <p className="col-7 "></p>
                <p className="col-2 placeholder"></p>
              </div>
              <div className="row mb-4">
                <p className="col-3  placeholder"></p>
                <p className="col-7 "></p>
                <p className="col-2 placeholder"></p>
              </div>
              <div className="row mb-4">
                <p className="col-3  placeholder"></p>
                <p className="col-7 "></p>
                <p className="col-2 placeholder"></p>
              </div>
              <div className="row">
                <p className="col-3  placeholder"></p>
                <p className="col-7 "></p>
                <p className="col-2 placeholder"></p>
              </div>
            </div>
          </SkeletonCard>
          <div className={`${loading && 'd-none'} card-body pb-0`}>
            <div className="mb-3 d-flex justify-content-between onboarded-popup-row">
              <span className="fw-medium">Total Onboarded:</span>
              <span className="fw-bold" style={{ fontWeight: 800 }}>
                {onboarded}
              </span>
            </div>

            <div className="mb-3 d-flex justify-content-between onboarded-popup-row">
              <span className="fw-medium">Onboarded via WhatsApp: </span>
              <span className="fw-bold" style={{ fontWeight: 800 }}>
                {loading ? "Loading..." : (onboarded - ( Number(onBoardedPatients?.sms_count|| 0)+ Number(onBoardedPatients?.other_count || 0) ) )}
              </span>
            </div>

            <div className="mb-4 d-flex justify-content-between onboarded-popup-row">
              <span className="fw-medium">Onboarded via SMS:</span>
              <span className="fw-bold" style={{ fontWeight: 800 }}>
                {loading ? "Loading..." : onBoardedPatients?.sms_count|| 0}
              </span>
            </div>

            <div className="mb-4 d-flex justify-content-between onboarded-popup-row">
              <span className="fw-medium">Onboarded via Other:</span>
              <span className="fw-bold" style={{ fontWeight: 800 }}>
                {loading ? "Loading..." : onBoardedPatients?.other_count || 0}
              </span>
            </div>


          </div>
        </div>
      </div>
      <style>
        {`
                    .onboarded-popup-heading {
                        font-size: 1.75rem;
                    }
                    .onboarded-popup-row {
                        font-size: 1.1rem;
                    }
                    @media (max-width: 768px) {
                        .onboarded-popup-heading {
                            font-size: 1.3rem;
                        }
                        .onboarded-popup-row {
                            font-size: 1rem;
                        }
                    }
                    @media (max-width: 480px) {
                        .onboarded-popup-heading {
                            font-size: 1.05rem;
                        }
                        .onboarded-popup-row {
                            font-size: 0.95rem;
                        }
                    }
                `}
      </style>
    </div>
  );
};

export default OnboardedPatientsPopup;
